export default __webpack_public_path__ + "static/media/emo_judge.b28a5a56.svg";